export default function match(value, { unique }) {
  /** @description forcing to an array */
  const uniqueValues = [].concat(unique).find((uniqueValue) => uniqueValue === value);

  if (uniqueValues) {
    return 'Answer must be unique';
  }

  return null;
}
